import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNoResults = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 96,
	height: 96,
	viewBox: "0 0 96 96",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_875_22892)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M40 52L30 62H42L32 72",
				stroke: "black",
				strokeWidth: 4,
				strokeLinejoin: "bevel"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M46 14H26V32H46V14Z",
				stroke: "black",
				strokeWidth: 4,
				strokeLinejoin: "bevel"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M26 44H46",
				stroke: "black",
				strokeWidth: 4,
				strokeLinejoin: "bevel"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M54 44H64V82H74V38",
				stroke: "black",
				strokeWidth: 4,
				strokeLinejoin: "bevel"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M18 82H54",
				stroke: "black",
				strokeWidth: 4,
				strokeLinejoin: "bevel"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M78 30V24",
				stroke: "black",
				strokeWidth: 4,
				strokeLinejoin: "bevel"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M70 30V24",
				stroke: "black",
				strokeWidth: 4,
				strokeLinejoin: "bevel"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M54 90H18V11C18 8.2 20.2 6 23 6H49C51.8 6 54 8.2 54 11V90Z",
				stroke: "black",
				strokeWidth: 4,
				strokeLinejoin: "bevel"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M68 32C68 35.4 70.6 38 74 38C77.4 38 80 35.4 80 32V30H68V32Z",
				stroke: "black",
				strokeWidth: 4,
				strokeLinejoin: "bevel"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_875_22892",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 96,
			height: 96,
			fill: "white"
		})
	}) })]
});
export default SvgNoResults;
